'use strict';
const svgPath = require('svg-path-properties');
module.exports = function pointAlongPath(svgPathString, ratio) {
	const fixPath = function (svgString) {
			const parsed = svgPath.parse(svgString);
			if (parsed.length === 1 &&
				parsed[0][0] === 'M') {
				return svgString + 'L' + (parsed[0][1] + 1) + ',' + parsed[0][2];
			}
			return svgString;
		},
		path = svgPath.svgPathProperties(fixPath(svgPathString)),
		length = path.getTotalLength();
	if (length && Number.isFinite(length)) {
		return path.getPointAtLength(length * ratio);
	} else {
		return false;
	}
};
